/**
 * L⚡t-ning Theme Switcher
 * Handles theme switching between light and dark modes
 */

// Function to set the theme
function setTheme(themeName) {
  localStorage.setItem('theme', themeName);
  document.documentElement.setAttribute('data-theme', themeName);
}

// Function to toggle between light and dark themes
function toggleTheme() {
  if (localStorage.getItem('theme') === 'dark') {
    setTheme('light');
    return 'light';
  } else {
    setTheme('dark');
    return 'dark';
  }
}

// Initialize theme on page load
function initTheme() {
  // Check for saved theme preference or use preferred color scheme
  const savedTheme = localStorage.getItem('theme');
  
  if (savedTheme) {
    setTheme(savedTheme);
  } else {
    // Check if user prefers dark mode
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
    
    if (prefersDarkScheme.matches) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  }
}

// Export functions for use in Vue components
export { setTheme, toggleTheme, initTheme };